// Shared helpers for rendering a lead's photoAvailability.checkedSources —
// the per-source provenance the ingestion pipeline records when a lead doesn't
// end up with a full gallery. Consumed by PhotoAvailabilityNotice (the photo
// panel) and ingestionReport (the 3-tab inspector selector) so the
// outcome vocabulary stays in one place.

// Maps a checkedSources outcome to its display text + whether it's a "found" tick.
export const OUTCOME = {
    photos: { ok: true, text: 'photos found' },
    no_photos: { ok: false, text: 'no photos' },
    empty: { ok: false, text: 'empty' },
    error: { ok: false, text: "couldn't access" },
    not_provided: { ok: false, text: 'not provided' },
    street_view_only: { ok: false, text: 'street view only' },
    login_required: { ok: false, text: 'login required' },
    couldnt_read: { ok: false, text: "couldn't read" },
    couldnt_open: { ok: false, text: "couldn't open (broken link)" },
};

// Reason string stamped by functions/utils/photoAvailability.classifyFolderError
// when a cloud folder is shared VIEW-ONLY (owner disabled download/copy). The
// photos exist and the folder is openable — we just can't pull the bytes. Kept
// in sync with the backend literal.
export const VIEW_ONLY_REASON = 'sender disabled downloads — view-only';

// If a lead's photos live in a folder the sender shared view-only (download
// disabled), return { url, label, provider } so the UI can link to VIEW them;
// otherwise null. Reads raw checkedSources (not summarized) so the url survives.
export function deriveViewOnlyFolder(photoAvailability) {
    const rows = photoAvailability && photoAvailability.checkedSources;
    if (!Array.isArray(rows)) return null;
    const row = rows.find((r) => r && r.reason === VIEW_ONLY_REASON && r.url);
    return row ? { url: row.url, label: row.label || 'folder', provider: row.kind || null } : null;
}

// Collapse duplicate rows (multiple click-tracker links resolve to the same
// listing) by label+outcome, keep the highest count, cap the list.
export function summarizeSources(rows = []) {
    const map = new Map();
    for (const r of rows) {
        if (!r || !r.label) continue;
        const key = `${r.label}|${r.outcome}`;
        const prev = map.get(key);
        if (!prev || (r.count || 0) > (prev.count || 0)) map.set(key, r);
    }
    return Array.from(map.values()).slice(0, 5);
}
